import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalBasesQuery() {
    let url = "/LegalBasis/LegalObligationId/";
    let query = useDotLegalQuery<string>(url);

    return {
        legalObligationId: query.data ?? "",
    };
}
